import React from 'react';
import VoiceComponent from './VoiceComponent';
import VoiceComponent1 from './VoiceComponent1';
import VoiceComponent2 from './VoiceComponent2';

import './App.css';


function App(props) {

  return (
    <div id='main'>
      <div className="main-inner">
       
        <h1 className="main-title">
        Global Prosody Style Transfer Without Text Transcriptions:
          <font className="red"> Audio Demo</font>
        </h1>
        <div className="to-reviewer">
          <font className="red">To reviewers: </font>
          The reference list was accidentally not included in the main paper, but it is included in the supplementary material. You can also find the reference list 
           <a className="red" href="/files/reference_list.pdf" target="_blank"> here</a>
          . We apologize for the inconvenience!
        </div>
        <div className="introduction">
         <p>
          This demo webpage contains example audios generated by <font className="red">AutoPST</font>, which is a voice style transfer algorithm that not only converts timbre, but also
          <font className="red"> converts the prosody</font> to match the target speaker.
         </p>
         <p style={{marginTop: "1.5em"}}>
         In this demo, you will hear voice conversion results between a <font className="red">slow speaker</font> and a <font className="red">fast speaker</font>. The generated utterances are from the following algorithms:
         </p>
         <ul>
          <li><font className="red">AutoVC</font> – A voice conversion algorithm that does not convert prosody</li>
          <li><font className="red">RR</font> (Random Resampling) – A voice conversion algorithm that does rhythm disentanglement using a random resampling scheme proposed in<sup>[1]</sup>.</li>
          <li><font className="red">AutoPST</font> – The proposed algorithm, which disentangles rhythm with a similarity-based resampling algorithm and a two-stage training scheme.</li>
        </ul>
        <p style={{fontSize: "70%"}}>[1] Qian, Kaizhi, et al. "Unsupervised speech decomposition via triple information bottleneck." International Conference on Machine Learning. PMLR, 2020</p>
        </div>
        <p style={{marginTop: "1.5em"}}><font style={{fontSize: "120%", fontWeight: "bold"}}>1. Slow-to-Fast Conversion</font> (converting from a slow speaker to a fast speaker)</p>
        <VoiceComponent title="Utterance 1" u1="/ground_truth/p245/p245_003001.wav" u2="/ground_truth/p231_007.wav"
        u3="/autovc/700000_1.0/p245_p231_003001.wav" u4="/naive_rr/500000_1.0/p245_p231_003001.wav" u5="/31_01/580000_1.0/p245_p231_003001.wav"/>
        
        <VoiceComponent title="Utterance 2" u1="/ground_truth/p270/p270_003002.wav" u2="/ground_truth/p231_007.wav"
        u3="/autovc/700000_1.0/p270_p231_003002.wav" u4="/naive_rr/500000_1.0/p270_p231_003002.wav" u5="/31_01/580000_1.0/p270_p231_003002.wav"/>
        
        <VoiceComponent title="Utterance 3" u1="/ground_truth/p270/p270_024001.wav" u2="/ground_truth/p239_007.wav"
        u3="/autovc/700000_1.0/p270_p239_024001.wav" u4="/naive_rr/500000_1.0/p270_p239_024001.wav " u5="/31_01/580000_1.0/p270_p239_024001.wav"/>

        <VoiceComponent title="Utterance 4" u1="/ground_truth/p245/p245_001.wav" u2="/ground_truth/p239_007.wav"
        u3="/autovc/700000_1.0/p245_p239_001.wav" u4="/naive_rr/500000_1.0/p245_p239_001.wav" u5="/31_01/580000_1.0/p245_p239_001.wav"/>
        
        
        
        <VoiceComponent title="Utterance 5" u1="/ground_truth/p270/p270_024002.wav" u2="/ground_truth/p239_007.wav"
        u3="/autovc/700000_1.0/p270_p239_024002.wav" u4="/naive_rr/500000_1.0/p270_p239_024002.wav" u5="/31_01/580000_1.0/p270_p239_024002.wav"/>
        
       

        <p style={{marginTop: "1.5em"}}><font style={{fontSize: "120%", fontWeight: "bold"}}>2. Fast-to-Slow Conversion</font> (converting from a fast speaker to a slow speaker)</p>
        
        <VoiceComponent title="Utterance 1" u1="/ground_truth/p231/p231_003001.wav" u2="/ground_truth/p245_007.wav"
        u3="/autovc/700000_1.0/p231_p245_003001.wav" u4="/naive_rr/500000_1.0/p231_p245_003001.wav" u5="/31_01/580000_1.0/p231_p245_003001.wav"/>
        
        <VoiceComponent title="Utterance 2" u1="/ground_truth/p239/p239_003002.wav" u2="/ground_truth/p245_007.wav"
        u3="/autovc/700000_1.0/p239_p245_003002.wav" u4="/naive_rr/500000_1.0/p239_p245_003002.wav" u5="/31_01/580000_1.0/p239_p245_003002.wav"/>
        <VoiceComponent title="Utterance 3" u1="/ground_truth/p231/p231_001.wav" u2="/ground_truth/p270_007.wav"
        u3="/autovc/700000_1.0/p231_p270_001.wav" u4="/naive_rr/500000_1.0/p231_p270_001.wav" u5="/31_01/580000_1.0/p231_p270_001.wav"/>
        
        <VoiceComponent title="Utterance 4" u1="/ground_truth/p231/p231_024001.wav " u2="/ground_truth/p270_007.wav"
        u3="/autovc/700000_1.0/p231_p270_024001.wav" u4="/naive_rr/500000_1.0/p231_p270_024001.wav" u5="/31_01/580000_1.0/p231_p270_024001.wav"/>
        
        <VoiceComponent title="Utterance 5" u1="/ground_truth/p239/p239_006001.wav" u2="/ground_truth/p270_007.wav"
        u3="/autovc/700000_1.0/p239_p270_006001.wav" u4="/naive_rr/500000_1.0/p239_p270_006001.wav" u5="/31_01/580000_1.0/p239_p270_006001.wav"/>
        
        <p style={{marginTop: "1.5em"}}><font style={{fontSize: "120%", fontWeight: "bold"}}>3. Restoring Abnormal Rhythm Patterns</font></p>
        <p style={{marginTop: "0.8em"}}>This section corresponds to <font className="red">Section 5.5</font> of the main
          paper. We create some abnormal rhythm patterns by
          doubling the durations of some words or phrases of an
          utterance, and then use different algorithms to
          <font className="red"> reconstruct the input</font>. The ideal outcome is that the
          abnormal patterns can be restored in the reconstructed
          utterance.</p>
        <VoiceComponent1 title="Utterance 1" u1="/abn/original/p239_003001_abn.wav" u2="/abn/naive_rr/p239_003001_rc.wav" u3="/abn/ours/p239_003001_rc.wav"
        t1="Six spoons of fresh snow peas." t2="spoons"/>
        <VoiceComponent1 title="Utterance 2" u1="/abn/original/p231_024001_abn.wav" u2="/abn/naive_rr/p231_024001_rc.wav" u3="/abn/ours/p231_024001_rc.wav"
        t1="This is a very common type of bow." t2="bow"/>
        <VoiceComponent1 title="Utterance 3" u1="/abn/original/p245_024001_abn.wav" u2="/abn/naive_rr/p245_024001_rc.wav" u3="/abn/ours/p245_024001_rc.wav"
        t1="This is a very common type of bow." t2="common type of bow"/>
        <VoiceComponent1 title="Utterance 4" u1="/abn/original/p270_024002_abn.wav" u2="/abn/naive_rr/p270_024002_rc.wav" u3="/abn/ours/p270_024002_rc.wav"
        t1="One showing mainly red and yellow." t2="yellow"/>


        <p style={{marginTop: "1.5em"}}><font style={{fontSize: "120%", fontWeight: "bold"}}>4. Emotion Style Transfer</font> </p>
        <p style={{marginTop: "0.8em"}}>This section corresponds to <font className="red">Section 5.6</font> of the main
          paper. We convert between the slowest emotion category, 
          <font className="red"> sleepy</font>, and the fastest emotion category, <font className="red"> neutral</font>. Although the backbone algorithm, AutoVC, is not designed for emotion style transfer, AutoPST, with its ability of changing prosody, can still perceptibly change the emotion.</p>
        <p style={{marginTop: "0.8em", fontWeight: "bold"}}>4.1 Neutral to Sleepy Conversion (Fast to Slow)</p>

        <VoiceComponent2 title="Utterance 1" u1="/37_01/EmoV-DB_test/jenie/Neutral/neutral_29-56_0049.wav" u2="/37_01/EmoV-DB_truth/jenie_Sleepy_29-56_0051.wav"
        u3="/49_01/990000_1.0/jenie_Neutral_Sleepy_0049.wav" u4="/36_01/430000_1.0/jenie_Neutral_Sleepy_0049.wav" u5="/37_01/demo/jenie_Neutral_Sleepy_0049.wav"/>
        
        <VoiceComponent2 title="Utterance 2" u1="/37_01/EmoV-DB_test/sam/Neutral/neutral_29-56_0031.wav" u2="/37_01/EmoV-DB_truth/sam_Sleepy_29-56_0051.wav"
        u3="/49_01/990000_1.0/sam_Neutral_Sleepy_0031.wav" u4="/36_01/430000_1.0/sam_Neutral_Sleepy_0031.wav" u5="/37_01/demo/sam_Neutral_Sleepy_0031.wav"/>
        
        <VoiceComponent2 title="Utterance 3" u1="/37_01/EmoV-DB_test/josh/Neutral/neutral_29-56_0038.wav" u2="/37_01/EmoV-DB_truth/josh_Sleepy_29-56_0051.wav"
        u3="/49_01/990000_1.0/josh_Neutral_Sleepy_0038.wav" u4="/36_01/430000_1.0/josh_Neutral_Sleepy_0038.wav" u5="/37_01/demo/josh_Neutral_Sleepy_0038.wav"/>

        <VoiceComponent2 title="Utterance 4" u1="/37_01/EmoV-DB_test/bea/Neutral/Neutral_29-56_0031.wav" u2="/37_01/EmoV-DB_truth/bea_Sleepy_29-56_0051.wav"
        u3="/49_01/990000_1.0/bea_Neutral_Sleepy_0031.wav" u4="/36_01/430000_1.0/bea_Neutral_Sleepy_0031.wav" u5="/37_01/demo/bea_Neutral_Sleepy_0031.wav"/>

        <p style={{marginTop: "0.8em", fontWeight: "bold"}}>4.2 Sleepy to Neutral Conversion (Slow to Fast)</p>

        <VoiceComponent2 title="Utterance 1" u1="/37_01/EmoV-DB_test/jenie/Sleepy/sleepiness_29-56_0045.wav" u2="/37_01/EmoV-DB_truth/jenie_Neutral_29-56_0051.wav"
        u3="/49_01/990000_1.0/jenie_Sleepy_Neutral_0045.wav" u4="/36_01/430000_1.0/jenie_Sleepy_Neutral_0045.wav" u5="/37_01/demo/jenie_Sleepy_Neutral_0045.wav"/>

        <VoiceComponent2 title="Utterance 2" u1="/37_01/EmoV-DB_test/sam/Sleepy/sleepiness_29-56_0042.wav" u2="/37_01/EmoV-DB_truth/sam_Neutral_29-56_0051.wav"
        u3="/49_01/990000_1.0/sam_Sleepy_Neutral_0042.wav" u4="/36_01/430000_1.0/sam_Sleepy_Neutral_0042.wav" u5="/37_01/demo/sam_Sleepy_Neutral_0042.wav"/>

        <VoiceComponent2 title="Utterance 3" u1="/37_01/EmoV-DB_test/josh/Sleepy/sleepiness_29-56_0040.wav" u2="/37_01/EmoV-DB_truth/josh_Neutral_29-56_0051.wav"
        u3="/49_01/990000_1.0/josh_Sleepy_Neutral_0040.wav" u4="/36_01/430000_1.0/josh_Sleepy_Neutral_0040.wav" u5="/37_01/demo/josh_Sleepy_Neutral_0040.wav"/>

        <VoiceComponent2 title="Utterance 4" u1="/37_01/EmoV-DB_test/bea/Sleepy/sleepiness_29-56_0038.wav" u2="/37_01/EmoV-DB_truth/bea_Neutral_29-56_0051.wav"
        u3="/49_01/990000_1.0/bea_Sleepy_Neutral_0038.wav" u4="/36_01/430000_1.0/bea_Sleepy_Neutral_0038.wav" u5="/37_01/demo/bea_Sleepy_Neutral_0038.wav"/>
      </div>
      
    </div>
  );
}

export default App;
